var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitorMailList" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("VisitorMailBox", {
              staticClass: "col-md-3",
              attrs: {
                isGetChat: _vm.isGetChat,
                visitorMail: this.visitorMail,
              },
              on: {
                "visible-composer": function (e) {
                  _vm.isVisibleComposer = e
                },
                mailDetails: function (e) {
                  return (_vm.mailDetails = e)
                },
              },
            }),
            _vm._v(" "),
            _vm.isVisibleComposer
              ? _c("MailComposer", {
                  staticStyle: { width: "calc(100% - 400px)" },
                  attrs: {
                    isNewMail: true,
                    isVisitorDetail: true,
                    mailDetails: _vm.mailDetails,
                  },
                  on: {
                    closeEditor: function ($event) {
                      _vm.isVisibleComposer = false
                    },
                    newMailDetail: function (e) {
                      return (_vm.newMailDetail = e)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isVisibleComposer && _vm.mailDetails.length === 0
              ? _c("NoMessage", {
                  staticClass: "empty-mail",
                  attrs: { desc: _vm.$t("mail.mailNotFound"), newMail: "true" },
                  on: {
                    newComposer: function ($event) {
                      _vm.isVisibleComposer = true
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.isVisibleComposer && _vm.mailDetails.length > 0
              ? _c("ThreadViewer", {
                  staticClass: "col-md-9",
                  staticStyle: { height: "calc(100vh - 200px)" },
                  attrs: {
                    composerView: _vm.isVisibleComposer,
                    mailDetails: _vm.mailDetails,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }